export const documentTypes = [
  {
    type_id: 1,
    type_name: "Health Care",
    type_description: "Forms related to Medical Industry.",
    modules: [
      {
        id: 0,
        type_id: 1,
        type_name: "Health Care",
        type_description: "Forms related to Medical Industry.",
        module_id: 1,
        module_name: "Application for exemption governmentally owned property",
        module_description:
          "Application for exemption governmentally owned property",
        module_location: null,
        module_isActive: false,
      },
      {
        id: 1,
        type_id: 1,
        type_name: "Health Care",
        type_description: "Forms related to Medical Industry.",
        module_id: 2,
        module_name: "Assessment Worksheet Request Form",
        module_description: "Assessment Worksheet Request Form",
        module_location: null,
        module_isActive: false,
      },
      {
        id: 2,
        type_id: 1,
        type_name: "Health Care",
        type_description: "Forms related to Medical Industry.",
        module_id: 3,
        module_name: "Custom Document",
        module_description: "Custom Document",
        module_location: null,
        module_isActive: false,
      },
      {
        id: 3,
        type_id: 1,
        type_name: "Health Care",
        type_description: "Forms related to Medical Industry.",
        module_id: 4,
        module_name: "Managed Care Contract",
        module_description: "Managed Care Contract",
        module_location: null,
        module_isActive: false,
      },
      {
        id: 4,
        type_id: 1,
        type_name: "Health Care",
        type_description: "Forms related to Medical Industry.",
        module_id: 5,
        module_name: "Private Health Services Plan Agreement",
        module_description: "Private Health Services Plan Agreement",
        module_location: null,
        module_isActive: true,
      },
    ],
  },
  {
    type_id: 2,
    type_name: "Tax Forms",
    type_description: "Forms related to tax reporting and compliance.",
    modules: [
      {
        id: 5,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 37,
        module_name: "Form 1040 Parser",
        module_description:
          "Extracts information from the individual income tax return form (Form 1040).",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 6,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 38,
        module_name: "Form 1099-DIV Parser",
        module_description:
          "Extracts information from Form 1099-DIV, related to dividend income.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 7,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 39,
        module_name: "Form 1099-G Parser",
        module_description:
          "Extracts information from Form 1099-G, related to government payments and tax refunds.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 8,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 40,
        module_name: "Form 1099-INT Parser",
        module_description:
          "Extracts information from Form 1099-INT, related to interest income.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 9,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 41,
        module_name: "Form 1099-MISC Parser",
        module_description:
          "Extracts information from Form 1099-MISC, related to miscellaneous income.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 10,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 6,
        module_name: "Form 1099-R Parser",
        module_description:
          "Extracts information from Form 1099-R, related to retirement income.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 11,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 7,
        module_name: "Form SSA-1099 Parser",
        module_description:
          "Extracts information from Form SSA-1099, related to Social Security benefits.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 12,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 8,
        module_name: "Form W2 Parser",
        module_description:
          "Extracts information from Form W-2, related to wage and tax statements.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 13,
        type_id: 2,
        type_name: "Tax Forms",
        type_description: "Forms related to tax reporting and compliance.",
        module_id: 9,
        module_name: "Form W9 Parser",
        module_description:
          "Extracts information from Form W-9, related to taxpayer identification.",
        module_location: "eu and us",
        module_isActive: false,
      },
    ],
  },
  {
    type_id: 3,
    type_name: "Business and Partnership Tax Forms",
    type_description:
      "Forms related to business and partnership income tax reporting.",
    modules: [
      {
        id: 14,
        type_id: 3,
        type_name: "Business and Partnership Tax Forms",
        type_description:
          "Forms related to business and partnership income tax reporting.",
        module_id: 10,
        module_name: "Form 1065 Parser",
        module_description:
          "Extracts information from Form 1065, related to partnership income.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 15,
        type_id: 3,
        type_name: "Business and Partnership Tax Forms",
        type_description:
          "Forms related to business and partnership income tax reporting.",
        module_id: 11,
        module_name: "Form 1120 Parser",
        module_description:
          "Extracts information from Form 1120, related to corporate income tax.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 16,
        type_id: 3,
        type_name: "Business and Partnership Tax Forms",
        type_description:
          "Forms related to business and partnership income tax reporting.",
        module_id: 12,
        module_name: "Form 1120S Parser",
        module_description:
          "Extracts information from Form 1120S, related to S corporation income tax.",
        module_location: "eu and us",
        module_isActive: false,
      },
    ],
  },
  {
    type_id: 4,
    type_name: "Investment and Retirement Tax Forms",
    type_description:
      "Forms related to investment and retirement income tax reporting.",
    modules: [
      {
        id: 17,
        type_id: 4,
        type_name: "Investment and Retirement Tax Forms",
        type_description:
          "Forms related to investment and retirement income tax reporting.",
        module_id: 13,
        module_name: "Form 1040-D Parser",
        module_description:
          "Extracts information from Form 1040 Schedule D, related to capital gains and losses.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 18,
        type_id: 4,
        type_name: "Investment and Retirement Tax Forms",
        type_description:
          "Forms related to investment and retirement income tax reporting.",
        module_id: 14,
        module_name: "Form 1040-E Parser",
        module_description:
          "Extracts information from Form 1040 Schedule E, related to rental income and expenses.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 19,
        type_id: 4,
        type_name: "Investment and Retirement Tax Forms",
        type_description:
          "Forms related to investment and retirement income tax reporting.",
        module_id: 15,
        module_name: "Investment and Retirement Statement Parser",
        module_description:
          "Extracts information from investment and retirement account statements.",
        module_location: "eu and us",
        module_isActive: false,
      },
    ],
  },
  {
    type_id: 5,
    type_name: "Financial Documents",
    type_description: "Forms related to financial documents and statements.",
    modules: [
      {
        id: 20,
        type_id: 5,
        type_name: "Financial Documents",
        type_description:
          "Forms related to financial documents and statements.",
        module_id: 16,
        module_name: "Bank Statement Parser",
        module_description: "Extracts information from bank statements.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 21,
        type_id: 5,
        type_name: "Financial Documents",
        type_description:
          "Forms related to financial documents and statements.",
        module_id: 17,
        module_name: "Mortgage Statement Parser",
        module_description: "Extracts information from mortgage statements.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 22,
        type_id: 5,
        type_name: "Financial Documents",
        type_description:
          "Forms related to financial documents and statements.",
        module_id: 18,
        module_name: "Pay Slip Parser",
        module_description: "Extracts information from pay slips.",
        module_location: "eu and us",
        module_isActive: false,
      },
    ],
  },
  {
    type_id: 6,
    type_name: "Legal and Identity Documents",
    type_description: "Forms related to legal and identity documents.",
    modules: [
      {
        id: 23,
        type_id: 6,
        type_name: "Legal and Identity Documents",
        type_description: "Forms related to legal and identity documents.",
        module_id: 19,
        module_name: "France Driver License Parser",
        module_description:
          "Extracts information from French driver's licenses.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 24,
        type_id: 6,
        type_name: "Legal and Identity Documents",
        type_description: "Forms related to legal and identity documents.",
        module_id: 20,
        module_name: "France National ID Parser",
        module_description: "Extracts information from French ID cards.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 25,
        type_id: 6,
        type_name: "Legal and Identity Documents",
        type_description: "Forms related to legal and identity documents.",
        module_id: 21,
        module_name: "France Passport Parser",
        module_description: "Extracts information from French passports.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 26,
        type_id: 6,
        type_name: "Legal and Identity Documents",
        type_description: "Forms related to legal and identity documents.",
        module_id: 22,
        module_name: "Identity Document Proofing",
        module_description:
          "Predicts the validity of ID documents using multiple signals.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 27,
        type_id: 6,
        type_name: "Legal and Identity Documents",
        type_description: "Forms related to legal and identity documents.",
        module_id: 23,
        module_name: "US Driver License Parser",
        module_description: "Extracts information from US driver's licenses.",
        module_location: "eu and us",
        module_isActive: true,
      },
      {
        id: 28,
        type_id: 6,
        type_name: "Legal and Identity Documents",
        type_description: "Forms related to legal and identity documents.",
        module_id: 24,
        module_name: "US Passport Parser",
        module_description: "Extracts information from US passports.",
        module_location: "eu and us",
        module_isActive: false,
      },
    ],
  },
  {
    type_id: 7,
    type_name: "Invoices and Statements",
    type_description: "Forms related to invoices and financial statements.",
    modules: [
      {
        id: 29,
        type_id: 7,
        type_name: "Invoices and Statements",
        type_description: "Forms related to invoices and financial statements.",
        module_id: 25,
        module_name: "Expense Parser",
        module_description: "Extracts information from receipts.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 30,
        type_id: 7,
        type_name: "Invoices and Statements",
        type_description: "Forms related to invoices and financial statements.",
        module_id: 26,
        module_name: "Invoice Parser",
        module_description: "Extracts information from invoices.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 31,
        type_id: 7,
        type_name: "Invoices and Statements",
        type_description: "Forms related to invoices and financial statements.",
        module_id: 27,
        module_name: "Utility Parser",
        module_description: "Extracts information from utility statements.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 32,
        type_id: 7,
        type_name: "Invoices and Statements",
        type_description: "Forms related to invoices and financial statements.",
        module_id: 28,
        module_name: "HOA Statement Processor",
        module_description:
          "Extracts information from Homeowners Association statements.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 33,
        type_id: 7,
        type_name: "Invoices and Statements",
        type_description: "Forms related to invoices and financial statements.",
        module_id: 29,
        module_name: "Lending Doc Splitter/Classifier",
        module_description: "Identifies and classifies lending document types.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 34,
        type_id: 7,
        type_name: "Invoices and Statements",
        type_description: "Forms related to invoices and financial statements.",
        module_id: 30,
        module_name: "Procurement Doc Splitter",
        module_description:
          "Splits procurement documents bundled into a single PDF file.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 35,
        type_id: 7,
        type_name: "Invoices and Statements",
        type_description: "Forms related to invoices and financial statements.",
        module_id: 31,
        module_name: "Purchase Order Parser",
        module_description: "Extracts information from purchase orders.",
        module_location: "eu and us",
        module_isActive: false,
      },
    ],
  },
  {
    type_id: 8,
    type_name: "Real Estate and Housing",
    type_description: "Forms related to real estate and housing.",
    modules: [
      {
        id: 36,
        type_id: 8,
        type_name: "Real Estate and Housing",
        type_description: "Forms related to real estate and housing.",
        module_id: 32,
        module_name: "Extract from HOA statements",
        module_description:
          "Extracts information from Homeowners Association statements.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 37,
        type_id: 8,
        type_name: "Real Estate and Housing",
        type_description: "Forms related to real estate and housing.",
        module_id: 33,
        module_name:
          "Extract whether the signature and dates are populated in HUD 92900B",
        module_description: "Extracts information related to HUD 92900B forms.",
        module_location: "eu and us",
        module_isActive: false,
      },
    ],
  },
  {
    type_id: 9,
    type_name: "Miscellaneous",
    type_description: "Miscellaneous forms and document processing modules.",
    modules: [
      {
        id: 38,
        type_id: 9,
        type_name: "Miscellaneous",
        type_description:
          "Miscellaneous forms and document processing modules.",
        module_id: 34,
        module_name: "Extract over 50 fields from Fannie Mae Form 1003 (URLA)",
        module_description:
          "Extracts information from Fannie Mae Form 1003 (URLA).",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 39,
        type_id: 9,
        type_name: "Miscellaneous",
        type_description:
          "Miscellaneous forms and document processing modules.",
        module_id: 35,
        module_name:
          "Predict the validity of ID documents using multiple signals",
        module_description: "Provides ID document validity prediction.",
        module_location: "eu and us",
        module_isActive: false,
      },
      {
        id: 40,
        type_id: 9,
        type_name: "Miscellaneous",
        type_description:
          "Miscellaneous forms and document processing modules.",
        module_id: 36,
        module_name: "Extract structured information from VBA26-0551 forms",
        module_description: "Extracts information from VBA26-0551 forms.",
        module_location: "eu and us",
        module_isActive: false,
      },
    ],
  },
];
